import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import IconButton from '@mui/material/IconButton';

import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

import SideNavBar from './SideNavBar';

import { NavWidthContext } from '../../contexts';

import useSignOut from '../../hooks/useSignOut';

import { ReactComponent as InitioLogo } from '../../images/initio-logo.svg';
import redwoodseedLogo from '../../images/redwoodseed-logo.png';
import './NavBar.scss';
import useTheme from '../../hooks/useTheme';

export default function NavBar() {
  const nav = useNavigate();

  const [signOut] = useSignOut();

  const { navWidth } = useContext(NavWidthContext);
const theme = useTheme();
  // Conditionally render logo based on theme configuration
  const renderLogo = () => {
    if (!theme) {
      return <InitioLogo />;
    }
    if (theme.logoType === 'png') {
      return <img src={redwoodseedLogo} alt={`${theme.name} Logo`} />;
    }
    return <InitioLogo />;
  };

  return (
    <div className="NavBar" style={{ minWidth: navWidth }}>
      <SideNavBar />
      <IconButton
        className="initio-logo"
        // onClick={() => nav(window.location.assign(process.env.REACT_APP_ADMIN_HOSTNAME))}
         onClick={() => {
          let redirectUrl;
          
          if (process.env.NODE_ENV === 'development') {
            // Development: use env variable with tenant query parameter
            redirectUrl = process.env.REACT_APP_AUTH_HOSTNAME;
            if (theme?.name) {
              const urlParams = new URLSearchParams();
              urlParams.set('tenant', theme.name.toLowerCase());
              redirectUrl = `${redirectUrl}?${urlParams.toString()}`;
            }
          } else {
            // Production: use current domain (keeps tenant subdomain)
            redirectUrl = window.location.origin;
          }
          
          window.location.assign(redirectUrl);
        }}
      >
        {/* <InitioLogo /> */}
        {renderLogo()}
      </IconButton>
      <div className="right-nav">
        <IconButton
          disableRipple
          onClick={signOut}
          className="no-name-sign-out"
        >
          <LogoutOutlinedIcon className="log-out-icon" />
          <span>Sign out</span>
        </IconButton>
      </div>
    </div>
  );
}
